(ns io.daskul.webapp.effects.core
  "Re-frame effects for side effects."
  (:require
   [re-frame.core :as rf]))

;; LocalStorage effects
(rf/reg-fx
 :localstorage/set
 (fn [[key value]]
   (.setItem js/localStorage key value)))

(rf/reg-fx
 :localstorage/remove
 (fn [key]
   (.removeItem js/localStorage key)))

(rf/reg-fx
 :localstorage/clear
 (fn [_]
   (.clear js/localStorage)))

;; Navigation effect (consumer must provide implementation)
(defonce ^:private navigate-fn (atom nil))

(defn set-navigate-fn!
  "Set the navigation function to be called by :navigate effect.

   Example: (set-navigate-fn! #(pushy/set-token! %))"
  [f]
  (reset! navigate-fn f))

(rf/reg-fx
 :navigate
 (fn [route]
   (when @navigate-fn
     (@navigate-fn route))))
